import { render } from "./product-images.vue?vue&type=template&id=1f5cf12c&lang=pug"
import script from "./product-images.vue?vue&type=script&lang=js"
export * from "./product-images.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__